import { useMemo } from 'react';
import { get } from 'lodash';
import { ChipProps } from '@mui/material';

import { PartnerCompanyStatusTypes } from '~globals/types/enums';
import { getPartnerCompanyStatusTypeDescription } from '~utils/partnerCompany';

interface PartnerCompanyStatusInfoItem {
  description: string;
  color: NonNullable<ChipProps['color']>;
}

type PartnerCompanyStatusList = {
  [state in PartnerCompanyStatusTypes]: PartnerCompanyStatusInfoItem;
};

export const usePartnerCompanyStatusInfo = (
  stateId: PartnerCompanyStatusTypes,
): PartnerCompanyStatusInfoItem => {
  const stateList = useMemo<PartnerCompanyStatusList>(
    () => ({
      [PartnerCompanyStatusTypes.Pending]: {
        description: getPartnerCompanyStatusTypeDescription(
          PartnerCompanyStatusTypes.Pending,
        ),
        color: 'tertiary',
      },
      [PartnerCompanyStatusTypes.Active]: {
        description: getPartnerCompanyStatusTypeDescription(
          PartnerCompanyStatusTypes.Active,
        ),
        color: 'success',
      },
      [PartnerCompanyStatusTypes.Inactive]: {
        description: getPartnerCompanyStatusTypeDescription(
          PartnerCompanyStatusTypes.Inactive,
        ),
        color: 'error',
      },
    }),
    [],
  );

  const currentInfo = useMemo<PartnerCompanyStatusInfoItem>(
    () => get(stateList, stateId),
    [stateId, stateList],
  );

  return currentInfo;
};
